<!-- <app-page-header Heading="Email Configuration" Description="">
    <div class="btn btn-sm btn-primary" (click)="openEmailConfigForm()">New Email Configuration</div>
</app-page-header>


<div class="card mb-1">
    <div class="card-body px-1 py-0">
        <div class="d-flex align-items-end gap-3 filter-row w-100" id="filterContainer">
            <app-pagination [EnablePageSize]="true" [rowData]="emailConfigList"
                (pageSizeChanged)="handlePageSizeChange($event)">
            </app-pagination>

            Push this entire group to the right
            <div class="d-flex align-items-end gap-2 ms-auto pb-1">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
                        <a #tabLink class="nav-link" [ngClass]="this.selectedTab == tab.tabName ? 'active' : ''"
                            [attr.id]="tab.tabName+'-tab'" data-bs-toggle="tab"
                            [attr.data-bs-target]="'#' + tab.tabName" type="button" role="tab"
                            [attr.aria-controls]="tab.tabName" [attr.aria-selected]="this.selectedTab === tab.tabName"
                            (click)="onTabSelect(tab.tabName)">
                            <i class="{{tab.tabIcon}}"></i>
                        </a>
                    </li>
                </ul>
                Search Input
                <div class="d-flex align-items-end">
                    <input type="search" id="usearch" class="form-control form-control-sm" placeholder="Search"
                        [(ngModel)]="searchText" />
                </div>

                Load Button
                <div class="d-flex align-items-end">
                    <button class="btn btn-primary btn-sm" (click)="loadData()">Load Data</button>
                    <button class="btn btn-sm btn-secondary mx-1" (click)="clearSearchAndReload()">Clear</button>
                </div>

            </div>
        </div>
    </div>
</div> -->

<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-3">
        <app-page-header Heading="Email Configuration" Description="">
        </app-page-header>

        <app-pagination [EnablePageSize]="true" [rowData]="emailConfigList"
            (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center gap-2">

        <ul class="nav nav-pills me-2" id="myTab" role="tablist">
            <li class="nav-item" *ngFor="let tab of tabs" [ngbTooltip]="tab.tabName">
                <a class="nav-link py-1 px-2" [ngClass]="selectedTab == tab.tabName ? 'active' : 'text-secondary'"
                    style="cursor: pointer;" (click)="onTabSelect(tab.tabName)">
                    <i class="{{tab.tabIcon}}"></i>
                </a>
            </li>
        </ul>

        <input type="search" id="usearch" class="form-control form-control-sm" style="width: 200px;"
            placeholder="Search..." [(ngModel)]="searchText" (keyup.enter)="loadData()" />

        <button class="btn btn-sm btn-primary" (click)="loadData()" [disabled]="isLoading">
            Load
        </button>
        <button class="btn btn-sm btn-secondary" (click)="clearSearchAndReload()" [disabled]="isLoading">
            Clear
        </button>

        <button class="btn btn-sm btn-primary shadow-sm " (click)="openEmailConfigForm()" [disabled]="isLoading">
            <i class="bi bi-envelope-plus me-1"></i> New Email Configuration
        </button>
    </div>

</div>


<div class="tab-content" id="myTabContent">
    <div *ngFor="let tab of tabs" class="tab-pane fade" [ngClass]="{'show active': tab.tabName === this.selectedTab}"
        [attr.id]="tab.tabName" role="tabpanel" [attr.aria-labelledby]="tab.tabName + '-tab'">

        <ng-container [ngSwitch]="tab.tabName">
            <div *ngSwitchCase="'Tabular'">

                <app-uic-color-table [uicListData]="gListUIC" [tableData]="emailConfigList" [enableActionColumn]="true"
                    [DataLoading]="isLoading" [actionColumnLabel]="'Action'" enable
                    [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'},{actionName:'Reset Password',actionIcon:'fa fa-lock'},]"
                    (actionClick)="handleActionClick($event)" enableBadge="emailCofigId">
                </app-uic-color-table>


                <app-pagination [EnableNavigation]="true" [rowData]="emailConfigList"
                    (pageSizeChanged)="handlePageSizeChange($event)">
                </app-pagination>
            </div>

            <div *ngSwitchCase="'Grid'" class="row">

                <div *ngIf="isLoading">
                    <div class="row">
                        <div class="col-md-6 col-lg-3 custom-col-lg-4 mb-4" *ngFor="let item of [1,2,3,4]">
                            <div class="project-template-card p-2">
                                <ngx-skeleton-loader count="1" appearance="circle"
                                    [theme]="{ width: '40px', height: '40px' }"></ngx-skeleton-loader>
                                <ngx-skeleton-loader count="1"
                                    [theme]="{ height: '20px', width: '80%' }"></ngx-skeleton-loader>
                                <ngx-skeleton-loader count="3"
                                    [theme]="{ height: '12px', width: '100%', 'margin-top': '5px' }"></ngx-skeleton-loader>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!isLoading && emailConfigList.length === 0"
                    class="d-flex flex-column align-items-center justify-content-center py-5 w-100">
                    <img src="assets/images/no-data-found.svg" alt="No Data Found" style="width: 200px; opacity: 0.85;">
                    <p class="text-muted mt-3 mb-0 fw-semibold" style="font-size: 1rem;">No Email Configurations Found</p>
                    <p class="text-muted small">No email configurations have been set up yet. Click "New Email Configuration" to add one.</p>
                </div>


                <div class="col-md-6 col-lg-3 custom-col-lg-4 mb-4"
                    *ngFor="let emailConfig of emailConfigList; index as i">
                    <div class="project-template-card p-2" [ngClass]="'email-border'">

                        <!-- 🔹 Header: Updated Info (Left) & Dropdown (Right) -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <!-- Updated By & Date -->
                            <div class="small temp-bagde">
                                <i class="bi bi-fast-forward-fill me-1"></i>
                                {{ emailConfig.createdOn | date:'dd MMM,yyyy' }}

                            </div>




                            <!-- Dropdown -->
                            <div class="dropdown">
                                <i class="bi bi-three-dots-vertical menu-icon" data-bs-toggle="dropdown"
                                    aria-expanded="false"></i>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a class="dropdown-item d-flex align-items-center gap-2"
                                            (click)="handleActionClick({actionName:'Edit',rowData : emailConfig})">
                                            <i class="bi bi-pencil-square"></i> Edit
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a class="dropdown-item d-flex align-items-center gap-2"
                                            [routerLink]="[emailConfig.emailConfigId]">
                                            <i class="bi bi-eye"></i> view
                                        </a>
                                    </li> -->
                                    <li>
                                        <a class="dropdown-item text-danger d-flex align-items-center gap-2"
                                            (click)="handleActionClick({actionName:'Delete',rowData : emailConfig})">
                                            <i class="bi bi-trash"></i> Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 🔹 Title -->
                        <!-- <a [routerLink]="[emailConfig.emailConfigId]" class="pr-title fw-semibold mb-1 text-start">{{
                            emailConfig.iName}}</a> -->
                        <span class="pr-title fw-semibold mb-1 text-start text-primary">
                            {{ emailConfig.iName }}
                        </span>


                        <!-- 🔹 Description -->
                        <p class="description text-start"> <strong>Send From : </strong> {{ emailConfig.iFrom }}</p>
                        <!-- <p class="description text-start"><strong>Type : </strong>{{ service.alertType }}</p> -->

                        <!-- 🔹 Avatar & Project Owner -->
                        <div class="d-flex justify-content-between align-items-center small border-top pt-1 mt-auto">
                            <div class="d-flex align-items-center gap-2">
                                <!-- <div class="avatar">{{ service.lastExecutedOn}}</div> -->
                                <span class="pr-owner">
                                    <!-- <button class="btn btn-sm btn-primary" (click)="sendTestEmail(emailConfig)">Test Email</button> -->

                                    <div class="dropdown " data-bs-display="static" data-bs-auto-close="outside">
                                        <button class="btn btn-sm btn-primary dropdown-toggle" type="button"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            Test Email
                                        </button>
                                        <div class="dropdown-menu p-3" style="min-width: 300px;">
                                            <form>
                                                <!-- To Email -->
                                                <div class="mb-2">
                                                    <label for="toEmail" class="form-label">To</label>
                                                    <input type="email" class="form-control form-control-sm"
                                                        id="toEmail" placeholder="Enter email" required
                                                        [formControl]="sendTo">
                                                </div>
                                                <app-form-errors [control]="sendTo"></app-form-errors>

                                                <!-- DB Config Select -->
                                                <!-- <div class="mb-2">
                                                    <label for="dbConfig" class="form-label">DB Config</label>

                                                    <select class="form-select form-select-sm"
                                                        formControlName="emailConfigId">
                                                        <option value="">Select Config</option>
                                                        <option *ngFor="let config of emailDBList" [value]="config.dbConnId">{{ config.dbName }}</option>
                                                    </select>
                                                </div> -->

                                                <!-- Submit Button -->
                                                <div class="d-grid">

                                                    <button type="submit"
                                                        class="btn-sm d-flex align-items-center justify-content-center"
                                                        [disabled]="emailConfig.isLoading"
                                                        class="btn btn-sm btn-success"
                                                        (click)="sendTestEmail(emailConfig)">

                                                        <!-- Spinner while this row is loading -->
                                                        <span *ngIf="emailConfig.isLoading"
                                                            class="spinner-border spinner-border-sm me-2" role="status"
                                                            aria-hidden="true">
                                                        </span>

                                                        <!-- Button text -->
                                                        Send
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <span>Created On : {{ emailConfig.createdOn | date:'dd MMM, yyyy' }}</span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </ng-container>
    </div>
</div>





<ng-template #resetEmailPasswordModalContent>
    <div class="modal-header">
        <h5 class="modal-title">Reset DB Password - {{ resetEmailPasswordForm.get('eName')?.value }} </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="resetEmailPasswordModal.close()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="resetEmailPasswordForm">
            <div class="mb-3">
                <label class="form-label">From Email</label>
                <input type="text" class="form-control" formControlName="eFrom" readonly placeholder="Name">
            </div>
            <div class="mb-3">
                <label class="form-label">New Password</label><span style="color: red;">*</span>
                <input type="password" class="form-control" formControlName="newPassword" autocomplete="new-password"
                    placeholder="Enter New Password">
                <app-form-errors [control]="resetEmailPasswordForm.get('newPassword')"
                    fieldName="New Password"></app-form-errors>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" (click)="resetEmailPassword()">Submit</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="resetEmailPasswordModal.close()">Cancel</button>
    </div>
</ng-template>